import {useEffect, useState} from 'react';

import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import {AssetGroup, Pageable, PaginationSettings} from '@deviceinsight/ng-ui-api-client';

import ImpactInformation from './ImpactInformation';
import {
	DataProcessingDefinition,
	DataProcessingDefinitionValidation,
	validateDataProcessingDefinitionForAssetGroup
} from '../../api/dataProcessingDefinitionApi';

type Props = {
	assetGroup: AssetGroup;
	dataProcessingDefinition: DataProcessingDefinition;
	pageSize?: number;
};

const ImpactContainer = ({assetGroup, assetGroup: {id}, pageSize, dataProcessingDefinition}: Props) => {
	const initialPaginationSettings: PaginationSettings = {
		page: 0,
		size: pageSize || 10,
		sort: {
			property: 'name',
			direction: 'ASC'
		}
	};
	const kpiName = dataProcessingDefinition.definition.kpiName;
	const [isCalculating, setIsCalculating] = useState<boolean>(true);
	const [assetValidations, setAssetValidations] = useState<
		Pageable<DataProcessingDefinitionValidation> | null | undefined
	>(undefined);
	const [numberOfConflicts, setNumberOfConflicts] = useState<number>(0);
	const [paginationSettings, setPaginationSettings] = useState<PaginationSettings>(initialPaginationSettings);

	const onChangePage = (page: number) => {
		setPaginationSettings({...paginationSettings, page});
		setIsCalculating(true);
	};

	const onSort = (property: string, direction: 'ASC' | 'DESC') => {
		setPaginationSettings({
			...paginationSettings,
			sort: {
				property,
				direction
			}
		});
		setIsCalculating(true);
	};

	useEffect(
		() => {
			validateDataProcessingDefinitionForAssetGroup(dataProcessingDefinition, id, paginationSettings).then(
				(validations: Pageable<DataProcessingDefinitionValidation>) => {
					const assetsWithMissingDatapoints = {
						...validations,
						content: validations.content.filter((validation) => validation.missingDatapoints.length > 0)
					};
					setIsCalculating(false);
					setAssetValidations(assetsWithMissingDatapoints);
					setNumberOfConflicts(assetsWithMissingDatapoints.content.length);
				}
			);
		}, // eslint-disable-next-line react-hooks/exhaustive-deps
		[paginationSettings, isCalculating]
	);

	return (
		<SpinnerContainer show={isCalculating}>
			{isCalculating ? (
				<div className="impact-container-spacer" />
			) : (
				<ImpactInformation
					assetGroup={assetGroup}
					dataProcessingDefinitionName={kpiName ?? ''}
					assetValidations={assetValidations}
					numberOfConflicts={numberOfConflicts}
					paginationSettings={paginationSettings}
					onChangePage={onChangePage}
					onSort={onSort}
				/>
			)}
		</SpinnerContainer>
	);
};

export default ImpactContainer;
